import { render, staticRenderFns } from "./button-generic-back-v2.vue?vue&type=template&id=5224f89d&"
import script from "./button-generic-back-v2.vue?vue&type=script&lang=ts&"
export * from "./button-generic-back-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports